import React, { useState } from 'react'
import { AlertProvider } from './global-whatsapp/context/AlertContext';
import { Route, Routes } from 'react-router'

import PortalLandingPage from './global-whatsapp/app/portal/pages/PortalLandingPage';
import PortalRootPage from './global-whatsapp/app/portal/pages/PortalRootPage';
import PortalDashboardPage from './global-whatsapp/app/portal/pages/PortalDashboardPage';
import ComplaintListPage from './global-whatsapp/app/portal/pages/ComplaintListPage';
import ComplaintFormPage from './global-whatsapp/app/portal/pages/ComplaintFormPage';
import PortalGrievanceLandingPage from './global-whatsapp/app/portal/pages/PortalGrievanceLandingPage';
import ComplaintDetailsPage from './global-whatsapp/app/portal/pages/ComplaintDetailsPage';
import ChatBotInitPage from './global-whatsapp/app/chatbot/pages/ChatBotInitPage';
import ChatPage from './global-whatsapp/app/chatbot/pages/ChatPage';
import ChatPage2 from './global-whatsapp/app/chatbot/pages/ChatPage2';



function App() {
    return (
        <>
        <AlertProvider>
            <Routes>
                <Route path="/" element={ <PortalRootPage/> } />
                <Route path="/portal/:portalId" element={ <PortalLandingPage/> } /> 
                <Route path="/portal/:portalId/gid/:gid" element={ <PortalGrievanceLandingPage/> } /> 
                <Route path="/portal/complaint/details/:gid" element={ <ComplaintDetailsPage/> } />

                <Route path="/portal" element={ <PortalDashboardPage/> } />
                <Route path="/portal/complaint/form" element={ <ComplaintFormPage/> } />
                <Route path="/portal/complaint/list" element={ <ComplaintListPage/> } />

                {/* Chat Bot Related Work Start  */}
                <Route path="/chatbot/:portalId" element={ <ChatBotInitPage/> } /> 
                <Route path="/chatbot" element={ <ChatPage/> } />
                <Route path="/chatbot2" element={ <ChatPage2 /> } /> 
                {/* Chat Bot Related Work End  */}
            </Routes> 
        </AlertProvider>
        </>
    )
}
export default App